var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card-body",
    [
      _c("b-card-title", { attrs: { "title-tag": "h1" } }, [
        _vm._v("\n        " + _vm._s(_vm.newsCardTitle) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.newsItems && _vm.newsItems.length > 0
        ? [
            _c(
              "b-list-group",
              { attrs: { flush: "" } },
              _vm._l(_vm.newsItems, function(newsItem, key, index) {
                return _c(
                  "b-list-group-item",
                  {
                    key: index,
                    staticClass: "bg-transparent",
                    attrs: {
                      href: _vm.getLinkHref(newsItem),
                      target: "_blank"
                    },
                    on: {
                      click: function($event) {
                        return _vm.performClick(newsItem, $event)
                      }
                    }
                  },
                  [
                    _c("div", [
                      _c("h2", { staticClass: "list-group-item-title" }, [
                        _vm._v(_vm._s(newsItem.linkText))
                      ]),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "list-group-item-detail",
                        domProps: { innerHTML: _vm._s(newsItem.articleBlurb) }
                      })
                    ])
                  ]
                )
              }),
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c5bf8e4", { render: render, staticRenderFns: staticRenderFns })
  }
}